import { Autocomplete, TextField, Typography } from "@mui/material";

export default function SelectSituacoesFinanceiras({
    value,
    onChange
}: SelectSituacoesFinanceirasProps) {

  const listData: TSelectFinanceiroSituacoes[] = [
    { id: 1, nome: "Todos" },
    { id: 2, nome: "Em aberto" },
    { id: 3, nome: "Baixados" },
    { id: 4, nome: "Em atraso" },
    { id: 5, nome: "Vencendo hoje" },
  ];

  return (
    <Autocomplete
      disablePortal
      id="combo-box-demo"
      value={value}
      options={listData.map((i) => i.nome)}
      onChange={(_: any, newValue: TObjValue | null) => {
        onChange(newValue);
      }}
      renderOption={(props, option) => (
        <li {...props}>
            <Typography>{option}</Typography>
        </li>
      )}
      renderInput={(params) => <TextField {...params} label={"Situação"} fullWidth />}
    />
  );
}

interface SelectSituacoesFinanceirasProps {
    value: TObjValue | null;
    onChange: (arg: TObjValue | null) => void;
}

type TObjValue = string;

export type TSelectFinanceiroSituacoes = {
    id: number;
    nome: string;
};